import { Icon } from '@rbilabs/universal-components';
import { Text, View } from '@rbilabs/universal-components';
import { format, isValid } from 'date-fns';
import { useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { useLoyaltyContext } from 'state/loyalty';
import { primitive } from 'styles/constants/primitives';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

export const LoyaltyIncentiveCooldownContent = ({
  incentiveType,
  availableAfter,
}: {
  incentiveType: LoyaltyPromotionType;
  availableAfter?: Date;
}) => {
  const { formatMessage } = useIntl();

  const header =
    incentiveType === LoyaltyPromotionType.REWARD
      ? formatMessage({ id: 'rewardsCooldownTitle', defaultMessage: 'You just redeemed a reward' })
      : formatMessage({ id: 'offersCooldownTitle', defaultMessage: 'You just redeemed an offer' });

  return (
    <>
      <Icon variant="errorFill" size="14" marginRight="$2" />
      <View style={styles.cooldownMessageContainer}>
        <Text variant="headerFour" fontSize="xs" marginBottom="$0">
          {header}
        </Text>
        <Text variant="copyTwo" fontSize="xs">
          {isValid(availableAfter)
            ? formatMessage(
                { id: 'offersAvailableAt' },
                { time: format(availableAfter, 'hh:mm a') }
              )
            : formatMessage({ id: 'offersAvailableAtFallback' })}
        </Text>
      </View>
    </>
  );
};

export const LoyaltyIncentiveCooldownMessage = ({
  incentiveType,
}: {
  incentiveType: LoyaltyPromotionType;
}) => {
  const { offersCooldown, rewardsCooldown } = useLoyaltyContext();
  const cooldownInfo =
    incentiveType === LoyaltyPromotionType.OFFER ? offersCooldown : rewardsCooldown;

  if (!cooldownInfo.isActive) {
    return null;
  }

  return (
    <View style={styles.cooldownContainer}>
      <CenteredRowContainer style={styles.containerStyle} standardPadding>
        <LoyaltyIncentiveCooldownContent
          incentiveType={incentiveType}
          availableAfter={cooldownInfo.endsAt}
        />
      </CenteredRowContainer>
    </View>
  );
};

const styles = StyleSheet.create({
  // LoyaltyOffersCooldownMessage
  cooldownContainer: {
    backgroundColor: primitive.bk.$warningLight,
    paddingVertical: 8,
  },
  containerStyle: { maxWidth: WEB_SMALL_MAX_WIDTH, flexDirection: 'row', alignItems: 'center' },
  // LoyaltyOffersCooldownContent
  cooldownMessageContainer: {
    flexDirection: 'column',
  },
});
